<template>
  <div class="home">
    <h1>Hello Service Syclus</h1>
  </div>
</template>

<script>

export default {
  name: 'Home',
}
</script>
